var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("Have any feedback about this page? "),_c('a',{staticClass:"btn btn-default",attrs:{"target":"_blank","href":_vm.generatedFeedbackLink}},[_vm._v("Submit Feedback")])])
}
var staticRenderFns = []

export { render, staticRenderFns }